import React, { createContext, useContext } from 'react';
import { useProvider } from '~/Hooks';
import { useRequestOrganisation } from '~/requests';

export const useOrganisationWithoutContext = ({
  reactQueryEnabled,
}: {
  reactQueryEnabled?: boolean;
}) => {
  const { currentProvider } = useProvider();
  return useRequestOrganisation(reactQueryEnabled && !!currentProvider?.organisationId);
};

type OrganisationContextType = ReturnType<typeof useOrganisationWithoutContext>;

const OrganisationContext = createContext<OrganisationContextType>({} as OrganisationContextType);

export const OrganisationContextWrapper = (props: { children: React.ReactNode }) => {
  const store = useOrganisationWithoutContext({ reactQueryEnabled: true });
  const { children } = props;

  return <OrganisationContext.Provider value={store}>{children}</OrganisationContext.Provider>;
};

export const useOrganisation = () => useContext(OrganisationContext);
